var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.91 15.724a.887.887 0 01-1.287 0 .965.965 0 010-1.331l5.279-5.46H.909C.407 8.933 0 8.512 0 7.992s.407-.94.909-.94h15.977l-5.263-5.445a.965.965 0 010-1.332.887.887 0 011.286.001l6.824 7.059a.964.964 0 010 1.33l-6.824 7.059z",
    fill: "#596168",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default ForwardRef;